import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
} from 'react-admin';
import DatabaseItemTypesInput from './DatabaseItemTypesInput';

const DatabaseItemCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <DatabaseItemTypesInput source="type" validate={required()} />
            <TextInput source="hostname" validate={required()} />
            <NumberInput source="port" />
            <TextInput source="username" validate={required()} />
            <TextInput source="password" validate={required()} />
            <TextInput source="version" />
            <TextInput source="database_list" />
        </SimpleForm>
    </Create>
);

export default DatabaseItemCreate;